
import "../../css/Modal.css";
import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import ConNovedad from "../../assets/ConNovedad.svg";
import { memo } from 'react';
export class Modal extends Component {

  render() {
    return (
      <div className="modal-background">
        <div className="modal-container">
          <div className="modal-header1">
            <button className="modal-close" onClick={this.props.cerrarModal} >
              x
            </button>
          </div>
          {this.props.children}
          {(this.props.verBoton || this.props.verBoton2) ? (
            <div className="modal-container-botonGuardar">
              {this.props.verBoton && (
                this.props.textoBoton === "Denegar" ? (
                  <button className='denegar-btn' onClick={this.props.cerrarModal}>
                    Denegar
                    <img src={ConNovedad} alt="x" className="denegar-icon-img" />
                  </button>
                ) : (
                  <button className='modal-btn-submit' onClick={this.props.cerrarModal}>{this.props.textoBoton}</button>
                )
              )}
              {this.props.verBoton2 && (
                <button className='modal-btn-submit' onClick={this.props.onClickBoton2 ? this.props.onClickBoton2 : undefined}>{this.props.textoBoton2}</button>
              )}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}
export default memo(Modal);
